import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Moon, Flame, Leaf, Check, ArrowRight } from 'lucide-react';
const angles = [{
  id: 'mente',
  icon: Brain,
  iconColor: 'text-[#7C3AED]',
  iconBg: 'bg-[#F5F3FF]',
  accentColor: 'text-[#7C3AED]',
  borderColor: 'border-[#DDD6FE]',
  tagBg: 'bg-[#7C3AED]',
  label: 'MENTE',
  headline: 'Si sientes la mente "nublada"…',
  subhead: 'Protocolo de claridad mental',
  bullets: ['Ingredientes comunes, sin suplementos caros', 'Dosis exactas y preparación paso a paso', 'Rutina recomendada para resultados consistentes', 'Actúa en 45 minutos desde la primera toma']
}, {
  id: 'sueno',
  icon: Moon,
  iconColor: 'text-[#1D4ED8]',
  iconBg: 'bg-[#EFF6FF]',
  accentColor: 'text-[#1D4ED8]',
  borderColor: 'border-[#BFDBFE]',
  tagBg: 'bg-[#1D4ED8]',
  label: 'SUEÑO',
  headline: 'Si duermes pero no descansas…',
  subhead: 'Protocolo de sueño reparador',
  bullets: ['Conciliar el sueño más fácil, sin dependencia', 'Reducir despertares nocturnos', 'Despertar más descansado desde la primera noche', 'Sin somníferos ni efectos secundarios']
}, {
  id: 'dolor',
  icon: Flame,
  iconColor: 'text-[#B91C1C]',
  iconBg: 'bg-[#FEF2F2]',
  accentColor: 'text-[#B91C1C]',
  borderColor: 'border-[#FECACA]',
  tagBg: 'bg-[#B91C1C]',
  label: 'DOLOR',
  headline: 'Si tu cuerpo amanece rígido…',
  subhead: 'Protocolo anti-inflamación',
  bullets: ['Rodillas, manos, espalda — protocolo específico', 'Rutina de apoyo desde casa con ingredientes reales', 'Sin dañar el estómago como los AINEs', 'Respuesta en 72 horas de uso consistente']
}, {
  id: 'digestion',
  icon: Leaf,
  iconColor: 'text-[#166534]',
  iconBg: 'bg-[#F0FDF4]',
  accentColor: 'text-[#166534]',
  borderColor: 'border-[#BBF7D0]',
  tagBg: 'bg-[#166534]',
  label: 'DIGESTIÓN',
  headline: 'Si te sientes inflado después de comer…',
  subhead: 'Protocolo digestivo',
  bullets: ['Gases e hinchazón — alivio en 15–20 minutos', 'Pesadez post-comida con combinación correcta', 'Ingredientes que ya tienes en tu cocina', 'Sin antiácidos que destruyen tu absorción']
}];
export function AngleSections() {
  return <section className="py-8 px-4 bg-[#FEFCF6]" data-id="element-29">
      <div className="max-w-[800px] mx-auto" data-id="element-30">
        {/* Bridge copy */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12 bg-[#2C1810] text-white rounded-2xl px-6 py-8" data-id="element-31">
          <p className="text-[#E8DFD0] text-base md:text-lg leading-relaxed mb-2" data-id="element-32">
            Entraste por un síntoma.
          </p>
          <p className="text-white font-bold text-lg md:text-xl font-serif" data-id="element-33">
            Te llevas una biblioteca para 9 áreas completas,{' '}
            <span className="text-[#C17817]" data-id="element-34">
              organizada para que sepas exactamente qué hacer.
            </span>
          </p>
        </motion.div>

        {/* 4 Angle Sections */}
        <div className="space-y-6" data-id="element-35">
          {angles.map((angle, i) => {
          const Icon = angle.icon;
          return <motion.div key={angle.id} id={angle.id} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className={`bg-white rounded-2xl border-2 ${angle.borderColor} overflow-hidden shadow-sm`} data-id="element-36">
                <div className={`${angle.tagBg} text-white px-4 py-2 flex items-center gap-2`} data-id="element-37">
                  <Icon className="w-4 h-4" data-id="element-38" />
                  <span className="text-xs font-bold uppercase tracking-widest" data-id="element-39">
                    {angle.label}
                  </span>
                </div>

                <div className="p-5 md:p-6" data-id="element-40">
                  <h3 className="text-xl md:text-2xl font-serif font-bold text-[#2C1810] mb-1" data-id="element-41">
                    {angle.headline}
                  </h3>
                  <p className={`text-sm font-bold uppercase tracking-wide mb-4 ${angle.accentColor}`} data-id="element-42">
                    {angle.subhead}
                  </p>

                  <ul className="space-y-2 mb-5" data-id="element-43">
                    {angle.bullets.map((bullet, j) => <li key={j} className="flex items-start gap-2.5 text-sm text-[#2C1810]" data-id="element-44">
                        <Check className={`w-4 h-4 mt-0.5 shrink-0 ${angle.accentColor}`} data-id="element-45" />
                        <span data-id="element-46">{bullet}</span>
                      </li>)}
                  </ul>

                  <a href="#comprar" className={`inline-flex items-center gap-2 text-sm font-bold ${angle.accentColor} hover:underline`} data-id="element-47">
                    Quiero este protocolo <ArrowRight className="w-3.5 h-3.5" data-id="element-48" />
                  </a>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}